import React from 'react';

import useHierarchyViewsCreate from '../hooks/useHierarchyViewsCreate';

const withHierarchyViewsCreate = getRecordId => {
  return WrappedComponent => props => {
    useHierarchyViewsCreate({
      recordId: getRecordId ? getRecordId(props) : null,
    });

    return <WrappedComponent {...props} />;
  };
};

export default withHierarchyViewsCreate;
